export default {
      id: "ic-nav-menu-usage",
      viewBox: "0 0 26 26",
      url: "../dist/images/" + "sprite.svg#ic-nav-menu-usage",
      toString: function () {
        return this.url;
      }
    }